/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createNthRoots } from '../../factoriesAny.js';
export var nthRootsDependencies = {
  ComplexDependencies: ComplexDependencies,
  divideScalarDependencies: divideScalarDependencies,
  typedDependencies: typedDependencies,
  createNthRoots: createNthRoots
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesNthRoots.generated.js
// module id = 1604
// module chunks = 0